// eslint-disable no-unused-vars
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Typography,
  withStyles,
} from '@material-ui/core';
import { ExpandLess, InfoOutlined, Search as SearchIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
} from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ExcavatorModal, TruckModal } from '~/components/EquipmentStatusModals';
import PF2MEquipmentPool from '~/components/PF2MEquipmentPoolV2';
import PF2MTooltip from '~/components/PF2MTooltip';
import PF2MSearchInput from '~/components/PF2MSearchInput';
import {
  TruckAllocationModal,
  TruckAllocationModeModal,
  LoadAllocationModal,
} from '../../LoadSchedules/AllocationsTab/AllocationModal';
import OriginRow from './OriginRow';
import {
  getDispatchOriginsTrucks,
  getDispatchOriginsExcavators,
  updateTruckAllocations,
  setPendingTruckAllocationUpdate,
  setSelectedTruckAllocation,
  setSelectedLoadAllocation,
  getSyncStatus,
  getEquipmentStatuses,
  getEquipmentsSchedules,
  getEquipmentScheduleStatuses,
  getLoadAllocations,
} from '~/store/dispatch/actions';
import DispatchLabels from '../DispatchLabels';
import TruckOperators from '../TruckOperatorStatus';
import PF2MEquipmentScheduleModal from '~/components/PF2MEquipmentScheduleModal';
import PF2MFullScreenButton from '~/components/PF2MFullScreenButton';
import ContextMenu, { PF2MMenuItem, useContextMenu } from '~/components/PF2MMenuContext';
import { withModal } from '~/components/PF2MModal';
import PF2MWarnFeatureFlag from '~/PF2MWarnFeatureFlag';
import usePlatformConfiguration from '~/services/platformConfiguration';
import CollapseEquipmentList from '../CollapseEquipmentList';
import styles from '../styles';
import { DispatchDragNDropTypes, DispatchStatus, DispatchStatusNumber } from '~/utils';
import { newMomentDate, calculateDurationBytimestamp } from '~/utils/moment';
import { getCodeFromOrigin, getCodeFromStatus, toCodesMapByKey } from '~/utils/codes';
import { getCodes, getOperators } from '~/store/manager/actions';
import {
  getEquipmentTypes,
  getEquipmentGroups,
  getMaterials,
  getElements,
  getSubElements,
} from '~/store/nref/actions';
import PF2MEquipmentPoolFilter from '~/components/PF2MEquipmentPoolFilter';

import useRealtimeSignal from '../../useMqtt/useRealtimeSignal';
import useThrottledRealtimeRefresh from '../../useMqtt/useThrottledRealtimeRefresh';


// const TRUCK = 1;
const LOAD = 2;

// No meaning to have validation for one line temporary toggle feature
// eslint-disable-next-line react/destructuring-assignment, react/prop-types
const OffComp = props => <div>{props.children}</div>;

const GENERIC_LOAD_EQUIP = {
  id: null,
  equip_type_id: 1,
  equip_group_id: 0,
  equip_id: 0,
  equip_name: '',
  priority: null,
  origin_element_id: null,
  origin_element_point_id: null,
  status: 'OP',
};

const EquipmentScheduleModal = withModal(PF2MEquipmentScheduleModal);

const OriginsTabV2 = ({ classes }) => {
  const rootRef = React.useRef(0);

  const dispatch = useDispatch();
  const handleFS = useFullScreenHandle();

  const { t: translate } = useTranslation();

  const codes = useSelector(state => state.manager.codes);
  const operators = useSelector(state => state.manager.operators);

  const equipmentGroups = useSelector(state => state.nref.equipmentGroups);
  const equipmentTypes = useSelector(state => state.nref.equipmentTypes)
    .filter(r => [1, 2, 15].includes(r.id));
  const materials = useSelector(state => state.nref.materials);
  const elements = useSelector(state => state.nref.elements);
  const subElements = useSelector(state => state.nref.subElements);


  const syncStatus = useSelector(state => state.dispatch.syncStatus);
  const equipmentStatuses = useSelector(state => state.dispatch.equipmentStatuses);
  const equipmentsSchedules = useSelector(state => state.dispatch.equipmentsSchedules);

  const [dataLoaded, setDataLoaded] = useState(false);
  const [currentTruckModal, setCurrentTruckModal] = useState(null);
  const [currentExcavatorModal, setCurrentExcavatorModal] = useState(null);
  const [truckAllocationModalData, setTruckAllocationModalData] = useState();
  const [loadAllocationModalData, setLoadAllocationModalData] = useState();
  const [equipmentScheduleModal, setEquipmentScheduleModal] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [filterTextOrigin, setFilterTextOrigin] = useState('');
  const [filterTextLoad, setFilterTextLoad] = useState('');
  const [filterTextTruck, setFilterTextTruck] = useState('');

  const [poolEquipmentType, setPoolEquipmentType] = useState([]);
  const [poolEquipmentGroup, setPoolEquipmentGroup] = useState([]);
  const [poolEquipmentName, setPoolEquipmentName] = useState('');

  const [truckContextMenuData, openTruckContextMenu, closeTruckContextMenu] = useContextMenu();
  const [loadContextMenuData, openLoadContextMenu, closeLoadContextMenu] = useContextMenu();

  const processDisptachIndicatorsTime = (
    usePlatformConfiguration('process_dispatch_indicators_time')?.value || '0'
  );


  useEffect(() => {
    if (!dataLoaded) {
      dispatch(getCodes());
      dispatch(getOperators());
      dispatch(getMaterials());
      dispatch(getElements());
      dispatch(getSubElements());
      dispatch(getEquipmentsSchedules());
      dispatch(getEquipmentScheduleStatuses());
      dispatch(getSyncStatus());

      setDataLoaded(true);
    }
  });

  const refreshBoard = useCallback(() => {
    dispatch(getDispatchOriginsTrucks());
    dispatch(getDispatchOriginsExcavators());
    dispatch(getEquipmentStatuses());
    dispatch(getLoadAllocations());
  }, [dispatch]);

  const { signal } = useThrottledRealtimeRefresh({
    refresh: refreshBoard,
    throttleMs: 1000,
  });

  useRealtimeSignal({
    topic: 'DISPATCHUPDATE',
    onSignal: signal,
  });

  const useCreateMemoMapById = (array, key) => useMemo(
    () => Object.fromEntries(array?.map(item => [item[key], item]) || []),
    [array],
  );

  const pendingTruckAllocationUpdate = useSelector(
    state => state.dispatch.pendingTruckAllocationUpdate,
  );
  const loadAllocations = useSelector(state => state.dispatch.loadAllocations);
  const excavatorOrigins = useSelector(state => state.dispatch.excavatorOrigins);

  const codesByKey = useMemo(() => toCodesMapByKey(codes), [codes]);
  const operatorById = useCreateMemoMapById(operators, 'id_operator');
  const statusByEquipId = useCreateMemoMapById(equipmentStatuses, 'id_equip');
  const materialsById = useCreateMemoMapById(materials, 'id');
  const elementsById = useCreateMemoMapById(elements, 'id');
  const subElementsById = useCreateMemoMapById(subElements, 'id');
  const syncStatusByEquipId = useCreateMemoMapById(syncStatus, 'equip_id');

  // Status exibido na linha: o do equipamento (equipment_status); o do cache de
  // origens só como reserva, porque fica parado no último pacote depois do logout.
  const resolveExcavatorStatus = (excavator) => {
    const code = getCodeFromStatus(codesByKey, statusByEquipId[excavator.equip_id]);
    return DispatchStatusNumber[code?.code_type] || excavator.status;
  };

  const excavatorRows = [
    ...excavatorOrigins.filter(r => r.priority !== null),
    ...excavatorOrigins.filter(
      r => r.priority === null && resolveExcavatorStatus(r) === DispatchStatus.OP,
    ),
  ];

  const durationsByExcavatorRows = excavatorRows.map((excavator) => {
    const matchingStatuses = statusByEquipId[excavator.equip_id];
    const code = getCodeFromStatus(codesByKey, matchingStatuses);

    const durations = matchingStatuses
      ? calculateDurationBytimestamp(matchingStatuses.start_timestamp)
      : null;

    return {
      ...excavator,
      durations,
      start_timestamp: matchingStatuses?.start_timestamp,
      status: resolveExcavatorStatus(excavator),
      codes_id: code?.id,
      codes_name: code?.name ?? translate('validation:CodeNotFound'),
      operators_name:
        operatorById[matchingStatuses?.id_operator]?.name
        ?? translate('validation:OperatorNotFound'),
      current_material_name:
        materialsById[excavator.current_material_id]?.name
        ?? translate('validation:MaterialNotFound'),
      current_element_name:
        elementsById[matchingStatuses?.element_id]?.name
        ?? translate('validation:ElementNotFound'),
      current_origin_point_name:
        subElementsById[matchingStatuses?.point_id]?.name
        ?? translate('validation:SubElementNotFound'),
      timestamp_sync_request:
        syncStatusByEquipId[matchingStatuses?.id_equip]?.timestamp_sync_request
        ?? null,
    };
  });

  const truckEquipStatusMap = useSelector(state => (state.dispatch.truckOrigins || [])
    .filter(truck => truck?.equip_id)
    .map((truck) => {
      const truckStatus = statusByEquipId[truck.equip_id];
      const code = getCodeFromStatus(codesByKey, truckStatus)
        ?? getCodeFromOrigin(codesByKey, truck);

      const durations = truckStatus
        ? calculateDurationBytimestamp(truckStatus.start_timestamp)
        : null;

      const codeType = code?.code_type;

      const statusValue = codeType === undefined
        ? truck.status
        : DispatchStatusNumber[codeType];

      const operator = operatorById[truck?.operator_id];
      const syncStatusByStatus = syncStatusByEquipId[truckStatus?.id_equip];

      const materialByStatus = materialsById[truck?.current_material_id];

      const elementByStatus = elementsById[truck?.current_element_id];
      const currentSubElementName = subElementsById[truck?.point_id]?.name;

      return {
        ...truck,
        test_status: truckStatus,
        durations,
        status: statusValue,
        code_id: code?.id ?? truck.code_id,
        codes_name: code?.name ?? translate('validation:CodeNotFound'),
        start_timestamp: truckStatus?.start_timestamp,
        operators_name: operator?.name ?? translate('validation:OperatorNotFound'),
        current_material_name: materialByStatus?.name ?? translate('validation:MaterialNotFound'),
        timestamp_sync_request: syncStatusByStatus?.timestamp_sync_request ?? null,
        current_element_name: elementByStatus?.name ?? translate('validation:ElementNotFound'),
        current_origin_point_name: currentSubElementName ?? translate('validation:SubElementNotFound'),
      };
    }));

  const excavatorEquipStatusMap = useSelector(state => (
    (state.dispatch.excavatorOrigins || [])
      .filter(excavator => excavator?.equip_id)
      .map((excavator) => {
        const excavatorStatus = statusByEquipId[excavator.equip_id];
        const code = getCodeFromStatus(codesByKey, excavatorStatus);
        const codeType = code?.code_type;

        const operatorsName = operatorById[excavatorStatus?.id_operator]?.name;
        const currentMaterialName = materialsById[origin?.current_material_id]?.name;

        const currentOriginPointName = subElementsById[excavatorStatus?.point_id]?.name;

        return {
          ...excavator,
          test_status: excavatorStatus,
          status: DispatchStatusNumber[codeType],
          code_id: code?.id,
          codes_name: code?.name ?? translate('validation:CodeNotFound'),
          start_timestamp: excavatorStatus?.start_timestamp,
          operators_name: operatorsName ?? translate('validation:OperatorNotFound'),
          current_material_name: currentMaterialName ?? translate('validation:MaterialNotFound'),
          timestamp_sync_request: syncStatusByEquipId[excavator.equip_id]
            ?.timestamp_sync_request ?? null,
          current_origin_point_name: currentOriginPointName ?? translate('validation:SubElementNotFound'),
        };
      })
  ));

  const availablePoolEquips = [
    ...truckEquipStatusMap
      .map(TruckOperators)
      .filter(st => st.isHealthy && !st.isOnCicle && !st.isOnQuickPause)
      .map(({ to }) => to),
    ...excavatorEquipStatusMap.filter(
      r => !r.priority
        && (r.status === DispatchStatus.PO || r.status === DispatchStatus.IN),
    ),
  ];

  const maintenancePoolEquips = [
    ...truckEquipStatusMap
      .map(TruckOperators)
      .filter(st => !st.isHealthy)
      .map(({ to }) => to),
    ...excavatorEquipStatusMap.filter(
      r => !r.priority && r.status === DispatchStatus.MA,
    ),
  ];

  const rightLaneTrucks = truckEquipStatusMap
    .map(TruckOperators)
    .filter(st => st.isHealthy)
    .filter(st => st.isOnCicle || st.isOnQuickPause)
    .filter(st => st.isLoading)
    .map(({ to }) => to);

  const leftLaneTrucks = truckEquipStatusMap
    .map(TruckOperators)
    .filter(st => st.isHealthy)
    .filter(st => st.isOnCicle || st.isOnQuickPause)
    .filter(st => !st.isLoading)
    .map(({ to }) => to);


  const equipScheduleModalData = useMemo(() => {
    if (!equipmentsSchedules || !equipmentScheduleModal) {
      return {};
    }
    const currentEquip = equipmentsSchedules
      .find(e => (e.group_equipament_links_id === equipmentScheduleModal.equip_id));
    return currentEquip || {
      ...equipmentScheduleModal,
      equipaments_id: equipmentScheduleModal.equip_type_id,
      equipament_groups_id: equipmentScheduleModal.equip_group_id,
      group_equipament_links_id: equipmentScheduleModal.equip_id,
    };
  }, [equipmentScheduleModal, equipmentsSchedules]);

  const allocateTruck = (_e, item) => {
    dispatch(setSelectedTruckAllocation(item));
    setTruckAllocationModalData(true);
  };

  const editTruckSchedule = (_e, item) => {
    setEquipmentScheduleModal(item);
  };

  const allocateLoader = (_e, item) => {
    dispatch(setSelectedLoadAllocation(item));
    setLoadAllocationModalData(LOAD);
  };

  const editLoadSchedule = (_e, item) => {
    setEquipmentScheduleModal(item);
  };
  const filterTrucks = trucks => trucks
    .filter((truck) => {
      if (filterTextTruck !== '') {
        return (
          truck.equip_name
        && truck.equip_name !== null
        && truck.equip_name !== 0
        && truck.equip_name.toLowerCase().includes(filterTextTruck.toLowerCase())
        );
      }

      if (filterTextOrigin !== '') {
        return (
          (truck.current_origin_point_name
          && truck.current_origin_point_name !== null
          && truck.current_origin_point_name !== 0
          && truck.current_origin_point_name
            .toLowerCase()
            .includes(filterTextOrigin.toLowerCase()))
        );
      }

      return true;
    })
    .map(truck => truck.current_excavator_id);

  const getExcavatorNames = excavatorIds => [...new Set(
    durationsByExcavatorRows
      .filter(excavator => excavatorIds.some(
        id => excavator.equip_id?.toString() === id?.toString(),
      ))
      .map(excavator => excavator.equip_name)
      .filter(name => name !== null && name !== undefined),
  )];

  const filteredLeftLaneTrucks = filterTrucks(leftLaneTrucks);
  const filteredRightLaneTrucks = filterTrucks(rightLaneTrucks);

  const uniqueIdsLeft = getExcavatorNames(filteredLeftLaneTrucks);
  const uniqueIdsRight = getExcavatorNames(filteredRightLaneTrucks);

  const filterExcavator = durationsByExcavatorRows.filter((excavator) => {
    if (filterTextLoad !== '') {
      return (
        excavator.equip_name
        && excavator.equip_name !== null
        && excavator.equip_name !== 0
        && excavator.equip_name
          .toLowerCase()
          .includes(filterTextLoad.toLowerCase())
      );
    }

    if (
      filterTextLoad === ''
      && filterTextTruck === ''
      && filterTextOrigin === ''
    ) {
      return true;
    }

    if (filterTextOrigin !== '') {
      const matchesOriginOrExcavator = excavator.current_origin_point_name?.toLowerCase()
        .includes(filterTextOrigin.toLowerCase())
        || uniqueIdsLeft.some(
          id => excavator.equip_name?.toLowerCase() === id.toLowerCase(),
        )
        || uniqueIdsRight.some(
          id => excavator.equip_name?.toLowerCase() === id.toLowerCase(),
        );

      return matchesOriginOrExcavator;
    }

    return (
      uniqueIdsLeft.some(
        id => excavator.equip_name?.toLowerCase() === id.toLowerCase(),
      )
      || uniqueIdsRight.some(
        id => excavator.equip_name?.toLowerCase() === id.toLowerCase(),
      )
    );
  });

  const setEquipmentTypes = (e) => {
    setPoolEquipmentType([...e.target.value.map(r => r.value)]);
    setPoolEquipmentGroup(
      equipmentGroups.filter(
        equip => [...e.target.value.map(target => target.value)]
          .includes(equip.id_equipament),
      ).map(eg => eg.id),
    );
  };

  const filters = React.useMemo(() => ([
    {
      type: 'multiSelect',
      label: `${translate('common:EquipmentType')}`,
      value: poolEquipmentType,
      options: equipmentTypes.map(e => ({
        value: e.id,
        label: e.name,
      })),
      onChange: e => setEquipmentTypes(e),
      placeholder: `${translate('common:Select')}`,
    },
    {
      type: 'multiSelect',
      label: `${translate('common:EquipmentGroup')}`,
      value: poolEquipmentGroup,
      options: equipmentGroups
        .filter(r => poolEquipmentType.includes(r.id_equipament))
        .map(e => ({
          value: e.id,
          label: e.name,
        })),
      onChange: e => setPoolEquipmentGroup(e.target.value.map(r => r.value)),
      placeholder: `${translate('common:Select')}`,
    },
    {
      type: 'textField',
      label: `${translate('common:Equipment')}`,
      value: poolEquipmentName,
      onChange: e => setPoolEquipmentName(e?.target?.value),
      placeholder: `${translate('common:Find')}`,
    },
  ]), [
    poolEquipmentType,
    poolEquipmentGroup,
    poolEquipmentName,
    equipmentTypes,
    equipmentGroups,
  ]);

  const applyFiltersToPoolList = (list, listType, listGroup, equipName) => {
    const listFilteredByTypeList = list.filter(
      r => listType.length === 0 || listType.includes(r.equip_type_id),
    );

    const listFilteredByGroup = listFilteredByTypeList.filter(
      r => listGroup.length === 0 || listGroup.includes(r.equip_group_id),
    );

    if (!equipName?.trim()) {
      return listFilteredByGroup;
    }

    const search = equipName?.trim()?.toLowerCase();

    const listFilteredByName = listFilteredByGroup.filter(
      r => r.equip_name?.toLowerCase()?.includes(search),
    );

    return listFilteredByName;
  };

  const openTruckModal = (data) => {
    dispatch(getSyncStatus({ all: true },
      res => setCurrentTruckModal({
        ...data,
        ...res.find(item => item.equip_id === data.equip_id),
      })));
  };

  const openExcavatorModal = (data) => {
    dispatch(getSyncStatus({ all: true },
      res => setCurrentExcavatorModal({
        ...data,
        ...res.find(item => item.equip_id === data.equip_id),
      })));
  };

  const renderFilterTable = () => (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: '16px 8px',
        gap: '24px',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '45px',
        }}
      >
        <PF2MSearchInput
          value={filterTextOrigin}
          onChange={e => setFilterTextOrigin(e.target.value)}
          placeholder={translate('common:Find')}
          text={`${translate('common:SearchFor')} ${translate('common:Origin')}`}
          startIcon={<SearchIcon fontSize={'small'} color="primary" />}
        />
        <PF2MSearchInput
          value={filterTextLoad}
          onChange={e => setFilterTextLoad(e.target.value)}
          placeholder={translate('common:Find')}
          text={`${translate('common:SearchFor')} ${translate('common:LoadEquipment')}`}
          startIcon={<SearchIcon fontSize={'small'} color="primary" />}
        />
        <PF2MSearchInput
          value={filterTextTruck}
          onChange={e => setFilterTextTruck(e.target.value)}
          placeholder={translate('common:Find')}
          text={`${translate('common:SearchFor')} ${translate('common:TruckEquipment')}`}
          startIcon={<SearchIcon fontSize={'small'} color="primary" />}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <PF2MTooltip
          title={<DispatchLabels />}
          PopperProps={{ disablePortal: true }}
        >
          <IconButton className={classes.iconButton}>
            <InfoOutlined fontSize="small" />
          </IconButton>
        </PF2MTooltip>
        <PF2MFullScreenButton
          isFullScreenActive={handleFS.active}
          open={handleFS.enter}
          close={handleFS.exit}
          variant="outlined"
        />
      </div>
    </div>
  );

  const renderTableHeader = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
      <span className={classes.labelTypeSelector}>{translate('common:Element')}</span>
      <span className={classes.labelTypeSelector}>{translate('common:LoadEquipment')}</span>
    </div>
  );


  const renderGenericRow = () => {
    if (filterTextLoad !== '') return null;

    const workingExcavators = durationsByExcavatorRows.map(r => r.equip_id);

    const filteredLeftLane = leftLaneTrucks.filter((r) => {
      const isNotWorkingExcavator = !workingExcavators.includes(r.current_excavator_id);
      const matchesFilter = r.equip_name?.toLowerCase().includes(filterTextTruck?.toLowerCase());
      return isNotWorkingExcavator && matchesFilter;
    });

    const filterLeftOrigins = filteredLeftLane.filter((load) => {
      if (filterTextOrigin !== '') {
        return (
          load.current_origin_point_name?.toLowerCase()
            .includes(filterTextOrigin?.toLowerCase())
        );
      }
      return true;
    });

    const filteredRightLane = rightLaneTrucks.filter((r) => {
      const isNotWorkingExcavator = !workingExcavators.includes(r.current_excavator_id);
      const matchesFilter = r.equip_name?.toLowerCase().includes(filterTextTruck?.toLowerCase());
      return isNotWorkingExcavator && matchesFilter;
    });

    const filterRightOrigins = filteredRightLane.filter((load) => {
      if (filterTextOrigin !== '') {
        return (
          load.current_origin_point_name?.toLowerCase()
            .includes(filterTextOrigin?.toLowerCase())
        );
      }
      return true;
    });

    const leftLane = filterLeftOrigins.length > 0 || filterRightOrigins.length > 0
      ? leftLaneTrucks.filter(r => !workingExcavators.includes(r.current_excavator_id))
      : [];

    const rightLane = filterRightOrigins.length > 0 || filterLeftOrigins.length > 0
      ? rightLaneTrucks.filter(r => !workingExcavators.includes(r.current_excavator_id))
      : [];

    if (!leftLane.length && !rightLane.length) return null;

    return (
      <OriginRow
        origin={GENERIC_LOAD_EQUIP}
        leftLane={leftLane}
        rightLane={rightLane}
        isGenericRow
        loadAllocations={loadAllocations}
        openTruckModal={openTruckModal}
        openExcavatorModal={openExcavatorModal}
        onTruckContextMenu={openTruckContextMenu}
        onLoadContextMenu={openLoadContextMenu}
      />
    );
  };

  const renderRows = () => (
    <div style={{
      width: '100%',
      flex: 1,
      overflowY: 'scroll',
    }}
    >
      {renderFilterTable()}
      {renderTableHeader()}
      <div style={{
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
      }}
      >
        <>
          {filterExcavator
            .map(r => (
              <OriginRow
                key={r.equip_id}
                origin={r}
                leftLane={leftLaneTrucks.filter(x => x.current_excavator_id === r.equip_id)}
                rightLane={rightLaneTrucks.filter(x => x.current_excavator_id === r.equip_id)}
                loadAllocations={loadAllocations}
                onTruckDrop={(item, allocationId) => {
                  if (!item.load_allocation_id) {
                    dispatch(updateTruckAllocations({
                      item,
                      key: 'load_allocation_id',
                      value: allocationId,
                      refresh: false,
                      skipLoading: true,
                    }));
                    return;
                  }

                  const newTruckAllocation = {
                    ...item,
                    load_allocation_id: allocationId,
                  };
                  dispatch(setPendingTruckAllocationUpdate(newTruckAllocation, true));
                }}
                openTruckModal={openTruckModal}
                openExcavatorModal={openExcavatorModal}
                onTruckContextMenu={openTruckContextMenu}
                onLoadContextMenu={openLoadContextMenu}
              />
            ))}
          {renderGenericRow()}
        </>
      </div>
    </div>
  );

  const renderPools = () => (
    <Accordion
      defaultExpanded
      onChange={() => setExpanded(!expanded)}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={<ExpandLess />}
        id="1"
      >
        <Typography>{translate('common:AvailableEquipments')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div style={{ display: 'flex', width: '100%' }}>
          <PF2MEquipmentPoolFilter filters={filters} />
          <div style={{
            display: 'flex',
            marginTop: 10,
            width: '100%',
          }}
          >
            <PF2MEquipmentPool
              equips={
                applyFiltersToPoolList(
                  availablePoolEquips, poolEquipmentType, poolEquipmentGroup, poolEquipmentName,
                )
              }
              loadAllocations={loadAllocations}
              onEquipClick={() => null}
              onItemDropped={() => null}
              headerText={translate('common:AvailableEquipments').toUpperCase()}
              truckItemType={DispatchDragNDropTypes.POOL_TRUCK}
              loadItemType={DispatchDragNDropTypes.POOL_LOAD}
              acceptDrop={false}
              onContextMenu={{
                truck: openTruckContextMenu,
                loader: openLoadContextMenu,
              }}
              operationTypeEffective
            />
            <PF2MEquipmentPool
              equips={
                applyFiltersToPoolList(
                  maintenancePoolEquips, poolEquipmentType, poolEquipmentGroup, poolEquipmentName,
                )
              }
              loadAllocations={loadAllocations}
              onEquipClick={() => null}
              onItemDropped={() => null}
              headerText={translate('common:MaintenanceEquipments').toUpperCase()}
              customStyles={{ marginLeft: '10px' }}
              truckItemType={DispatchDragNDropTypes.POOL_TRUCK}
              loadItemType={DispatchDragNDropTypes.POOL_LOAD}
              acceptDrop={false}
              onContextMenu={{
                truck: openTruckContextMenu,
                loader: openLoadContextMenu,
              }}
              operationTypeEffective
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );

  const children = (
    <div className={classes.tabContainer}>
      <FullScreen handle={handleFS}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: handleFS.active ? '95%' : '82vh',
            backgroundColor: '#ffffff',
          }}
        >
          {renderRows()}
          {renderPools()}
        </div>

        <div ref={rootRef}>
          <TruckModal
            modalData={currentTruckModal}
            closeModal={() => setCurrentTruckModal(null)}
            classes={classes}
            container={() => rootRef.current}
          />

          <ExcavatorModal
            modalData={currentExcavatorModal}
            closeModal={() => setCurrentExcavatorModal(null)}
            classes={classes}
            container={() => rootRef.current}
          />

          <TruckAllocationModeModal
            isOpen={!!pendingTruckAllocationUpdate}
            refreshOrigins
            close={() => dispatch(setPendingTruckAllocationUpdate(null))}
            container={() => rootRef.current}
          />

          <ContextMenu
            {...truckContextMenuData}
            close={closeTruckContextMenu}
            container={rootRef.current}
          >
            <PF2MMenuItem onClick={allocateTruck}>
              {translate('common:AddEditAllocation')}
            </PF2MMenuItem>
            <PF2MMenuItem onClick={editTruckSchedule}>
              {translate('common:EditEquipmentScheduling')}
            </PF2MMenuItem>
          </ContextMenu>

          <ContextMenu
            {...loadContextMenuData}
            close={closeLoadContextMenu}
            container={rootRef.current}
          >
            <PF2MMenuItem onClick={allocateLoader}>
              {translate('common:AddEditAllocation')}
            </PF2MMenuItem>
            <PF2MMenuItem onClick={editLoadSchedule}>
              {translate('common:EditEquipmentScheduling')}
            </PF2MMenuItem>
          </ContextMenu>

          <TruckAllocationModal
            modalData={truckAllocationModalData}
            closeModal={() => setTruckAllocationModalData(null)}
            container={() => rootRef.current}
          />

          <LoadAllocationModal
            isOpen={loadAllocationModalData}
            close={() => setLoadAllocationModalData(null)}
            container={() => rootRef.current}
          />

          {equipScheduleModalData && (
            <EquipmentScheduleModal
              container={() => rootRef.current}
              modalData={equipmentScheduleModal}
              closeModal={() => setEquipmentScheduleModal(false)}
              settings={{
                skipBulkUpdate: true,
              }}
              fixed={{
                equipmentType: equipScheduleModalData.equipaments_id || 0,
                equipmentGroup: equipScheduleModalData.equipament_groups_id || 0,
                equipment: equipScheduleModalData.group_equipament_links_id || 0,
                startTime: newMomentDate(),
                duration: '00:30:00',
                element: equipScheduleModalData.flowchart_element_id || 0,
                subElement: equipScheduleModalData.flowchart_element_point_id || 0,
              }}
            />
          )}
        </div>
      </FullScreen>
    </div>
  );
  return (
    <PF2MWarnFeatureFlag
      flag={processDisptachIndicatorsTime >= 1}
      featureName="DispatchIndicators (process_dispatch_indicators_time >= 1)"
      OffComponent={OffComp}
      OnComponent={CollapseEquipmentList}
      props={{
        classes: { container: classes.tabContainer },
        children,
      }}
    />
  );
};

OriginsTabV2.propTypes = {
  classes: PropTypes.object.isRequired,
};

OriginsTabV2.defaultProps = {};

export default withStyles(styles)(OriginsTabV2);
